<template>
  <div :class="embedded ? '' : columnClassName">
    <column-header
      v-if="!embedded"
      :activeLayout="activeLayout"
      :columns="columns"
      :columnIndex="columnIndex"
      :components="components"
      :activeComponent="component"
      v-on:setActiveComponent="setActiveComponent"
    />
    <div :class="(embedded ? '' : bodyClassName + ' tabulator-parent')">
      <div class="flex-row space-between" style="align-items: flex-end;">
        <div>
          <h3>{{ _('Payment Plans') }}</h3>
          <label class="radiolabel" v-if="planType" style="font-weight: normal">
            <input type="checkbox" v-model="showAllTypes" /> {{ _('Show plans for other product types') }}
          </label>
        </div>
        <div class="button-col">
          <button type="button" class="btn btn-success" v-on:click="addPaymentPlanDialog">
            <i class="fa fa-fw fa-plus"></i> {{ _('New payment plan') }}
          </button>
        </div>
      </div>
      <Datatable
        :url="paymentPlansUrl"
        :options="paymentPlansTableOptions"
        ref="datatablePaymentPlans"
        :style="isModal ? 'height: 70dvh; min-height: 200px;' : ''"
      />
    </div>
    <nav class="modal-footer" v-if="isModal">
      <div class="button-row aling-right">
        <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      </div>
    </nav>
  </div>
</template>

<script>

import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable } from '#components'
const PaymentPlanDetails = defineAsyncComponent(() => import('~/components/modals/ModalPaymentPlanDetails'))
import { mapGetters } from 'vuex'

export default {
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      showAllTypes: false,
      paymentPlansTableOptions: {
        fixWidths: true,
        columns: [
          {
            title: 'ID',
            field: 'id',
            width: 70,
            responsive: 0
          },
          {
            title: _('Name'),
            field: 'name',
            widthGrow: 4,
            responsive: 0
          },
          {
            title: _('Type'),
            field: 'type',
            widthGrow: 2,
            responsive: 0,
            formatter: $this.paymentPlanTypeFormatter()
          }
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editPaymentPlan(id, name)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    ...mapGetters(['baseDomain']),
    planType () {
      return this.component && this.component.initData ? this.component.initData.planType : null
    },
    paymentPlansUrl () {
      const typeFilter = this.planType && !this.showAllTypes ? '&plantype=' + this.planType : ''
      return this.baseDomain + this.shopId + '/paymentplans.json?apikey=' + this.apiKey + '&rawformat=true' + typeFilter
    }
  },
  methods: {
    addPaymentPlanDialog () {
      this.editPaymentPlan()
    },
    editPaymentPlan (id, name, activeTab, skipState) {
      if (this.isModal) {
        this.showModal('paymentplandetails', PaymentPlanDetails, {
          props: {
            baseDomain: this.baseDomain,
            shopId: this.shopId,
            apiKey: this.apiKey,
            component: {
              initData: {
                modal: true,
                paymentPlanId: id,
                planType: this.planType
              }
            }
          },
          events: {
            save: () => {}
          },
          handlers: {
            closed: () => {
              this.reloadPaymentPlansList()
            }
          },
          width: 1000
        })
      } else {
        this.EventBus.$emit('showDetailsColumn', {
          shopId: this.shopId,
          component: 'PaymentPlanDetails',
          title: id ? (this._('Payment plan') + ' ' + id + (name ? ': ' + name : '')) : this._('New payment plan'),
          width: 6,
          data: {
            paymentPlanId: id,
            activeTab
          },
          skipState
        })
      }
    },
    reloadPaymentPlansList () {
      if (this.$refs && this.$refs.datatablePaymentPlans) {
        this.$refs.datatablePaymentPlans.reload()
      }
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if (!this.events) {
      const events = {}
      events['paymentplanUpdate'] = () => {
        return this.reloadPaymentPlansList()
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>
